"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.managerUsers")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.manager-users", {
            url: "/funcionarios",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-manager-users" */ "./manager-users.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.managerUsers")
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "employeeComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4"
                }
            }
        })
        .state("nucont.accounting.manager-users.employee", {
            url: "/contabilidade",
            views: {
                "employeeContent@nucont.accounting.manager-users": {
                    component: "employeeAaccountingComponent"
                }
            }
        });
}
